export const deleteCourseParticipant = async (setStatusMessage, course_ID, user_ID) => {
    try {
      const response = await fetch(
        "https://wad-backend.ws381566.remote.ac/removeEnrolledCourseUserAdmin.php?adminRequired=true&courseID=" + course_ID + "&userID=" + user_ID,
        {
          method: "DELETE",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
  
      const result = await response.json();
  
      if (result.status === "authenticationError") {
        window.location.href = "/login";
        return;
      }
  
      if (result.status === "success") {
        setStatusMessage(result.message);
      } else {
        setStatusMessage(result.message || "Failed to execute query");
      }
    } catch (error) {
      setStatusMessage(error.message);
    }
};